import { jsx as _jsx } from "react/jsx-runtime";
import { Masonry as MUIMasonry } from '@mui/lab';
const Masonry = (props) => {
    return _jsx(MUIMasonry, Object.assign({ sx: { width: 'auto' } }, props));
};
export default Masonry;
